import Grid from '@mui/material/Grid';
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { HouseboatOutlined } from "@mui/icons-material";
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Mastertemplate from "./Mastertemplate";
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useSelector } from 'react-redux';
import Cookies from "js-cookie";
import {useDispatch} from "react-redux";

export default function KontrakVO(props){


  const dispatch = useDispatch();

    ///////Variable to Pass On to Contract Generator machine//////////
    const [sellerData,setSellerData] = useState([
        {namaPerusahaan:"PT. SUPARDI NETHANEL HUSAIN", alamat:"", nomorTelepon:""},
    ]);
    
    const drawerWidth = 240;
    const navItems = [
      { name: 'Calendar', path: '/CalendarMobile' },
      { name: 'Confirm Signage', path: '/ConfirmSignatureMobile' },
      { name: 'Confirm Paid', path: '/PaidInvoiceMobile' },


  ];
    const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
  
    const handleDrawerToggle = () => {
      setMobileOpen((prevState) => !prevState);
    };

    const handleNavigation = (path) => {
      navigate(path);
      handleDrawerToggle();
    };
    const navigate = useNavigate();
    
  
    const container = window !== undefined ? () => window().document.body : undefined;
    const nowstate = useSelector(state => state);

    const filteredNavItems = navItems.filter(item => {
      if (item.name === 'Confirm Signage' && nowstate.user.role !== "owner") {
        return false;
      }
      if (item.name === 'Confirm Paid' && !(nowstate.user.role === "owner" || nowstate.user.role === "finance")) {
        return false;
    }

      return true;
    });
    const logout = () => {
      Cookies.set("user","")
      dispatch({
        type: "LOGOUT",
      });
      navigate("/login");
    };
    const drawer = (
      <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        Zanio
      </Typography>
      <Divider />
      <List>
        {filteredNavItems.map((item) => (
          <ListItem key={item.name} disablePadding>
            <ListItemButton onClick={() => handleNavigation(item.path)} sx={{ textAlign: 'center' }}>
              <ListItemText primary={item.name} />
            </ListItemButton>
          </ListItem>
        ))}
        <Typography sx={{mt:40}} onClick={() => logout()}>Logout</Typography>
      </List>
    </Box>
    );
    
    /////End Variable to Pass on to contract generator machine////////

    ///////Linear Progress Function///////////////////////////////////
    function LinearProgressWithLabel(props) {
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
              <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
              <Typography variant="body2" color="text.secondary">{`${Math.round(
                props.value,
              )}%`}</Typography>
            </Box>
          </Box>
        );
      }
    ///////Functions for Seller Company///////////////////////////////
    const handleSellerCompany = (event) => {
        const values =[...sellerData];
        values.namaPerusahaan = event.target.value;
        setSellerData(values)
    };
    ///////End of Functions for Seller Company///////////////////////////////

    return <>
                
                <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar component="nav">
        <Toolbar
        sx={{
    backgroundColor: '#313335',
    color: 'white', // Optional: to ensure text is visible on the black background
  }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
          >
            MUI
          </Typography>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            {filteredNavItems.map((item) => (
              <Button key={item.name} sx={{ color: '#fff' }}>
                {item.name}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
      <Mastertemplate></Mastertemplate>
    </Box>                              
            </>
    };